var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[(_vm.loading)?_c('span',[_c('i',{staticClass:"el-icon-loading"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }